import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { getSuggestedServices } from '../actions/ServiceList';
import * as MetricsEvents from '../constants/metrics';
import { trackC1 } from '../utils/trackMetric';

const SuggestedServicesErrorScreen = ({ staticContent, onReload = getSuggestedServices }) => {
  const { Text, Button } = UX2.Element;
  const { Card } = UX2.Group;

  useEffect(() => {
    trackC1(MetricsEvents.APPOINTMENTS_ZERO_STATE_ADD_RECOMMENDED_SERVICES_ERROR_IMPRESSION);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* eslint-disable max-len */
  const errorSvgImage = () => {
    return (
      <svg
        width='121'
        height='120'
        viewBox='0 0 121 120'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M60.5 72.25C60.8978 72.2499 61.2793 72.0918 61.5605 71.8105C61.8418 71.5293 61.9999 71.1478 62 70.75V42.001C62 41.6032 61.842 41.2216 61.5607 40.9403C61.2794 40.659 60.8978 40.501 60.5 40.501C60.1022 40.501 59.7206 40.659 59.4393 40.9403C59.158 41.2216 59 41.6032 59 42.001V70.75C59.0001 71.1478 59.1582 71.5293 59.4394 71.8105C59.7207 72.0918 60.1022 72.2499 60.5 72.25Z'
          fill='#111111'
        />
        <path
          d='M60.5 83.625C59.6054 83.6282 58.7369 83.9813 58.1036 84.6156C57.4712 85.2491 57.1164 86.1079 57.1172 87.003C57.118 87.8981 57.4743 88.7562 58.1078 89.3886C58.7398 90.0196 59.6097 90.375 60.5019 90.375C61.397 90.3748 62.2554 90.0189 62.8881 89.3858C63.5209 88.7527 63.8762 87.8941 63.8759 86.999C63.8757 86.1039 63.5198 85.2456 62.8867 84.6128C62.2536 83.9801 61.3951 83.6247 60.5 83.625Z'
          fill='#111111'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M71.9505 19.9495L110.245 86.967C111.392 88.9725 111.991 91.2439 111.983 93.5539C111.976 95.8638 111.362 98.1313 110.202 100.129C109.043 102.127 107.379 103.785 105.377 104.938C103.376 106.091 101.106 106.698 98.7962 106.698H22.2044C19.8945 106.697 17.6252 106.091 15.6236 104.938C13.6219 103.785 11.9582 102.127 10.7989 100.129C9.63956 98.1309 9.02533 95.8636 9.01765 93.5538C9.00998 91.2439 9.60913 88.9726 10.7551 86.967L49.0501 19.9495C50.1925 17.9213 51.8567 16.2357 53.87 15.0673C55.8834 13.899 58.1736 13.2905 60.5013 13.3049C62.8289 13.2904 65.118 13.8988 67.1312 15.0672C69.1444 16.2356 70.8084 17.9213 71.9505 19.9495ZM103.888 102.352C105.436 101.46 106.719 100.174 107.607 98.6233C108.512 97.0832 108.992 95.3303 108.998 93.5438C109.004 91.7573 108.535 90.0013 107.64 88.4553L69.345 21.4378C68.454 19.8785 67.1666 18.5825 65.6134 17.6811C64.0601 16.7797 62.2961 16.305 60.5003 16.305C58.7044 16.305 56.9404 16.7797 55.3872 17.6811C53.8339 18.5825 52.5465 19.8785 51.6555 21.4378L13.3606 88.4553C12.4751 90.0045 12.0121 91.7591 12.0179 93.5435C12.0237 95.3279 12.4981 97.0795 13.3936 98.6229C14.2891 100.166 15.5743 101.447 17.1206 102.338C18.6669 103.229 20.42 103.697 22.2044 103.698H98.7962C100.583 103.708 102.34 103.244 103.888 102.352Z'
          fill='#111111'
        />
      </svg>
    );
  };
  /* eslint-enable max-len */

  return (
    <>
      <Card
        style={{
          height: '300px',
          width: '600px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        { errorSvgImage() }

        <Text style={{ fontSize: '24px', fontWeight: '700', padding: '0 10px' }}>
          { staticContent.unexpectedErrorLabel || 'An unexpected error occurred' }
        </Text>
        <Text style={{ padding: '0 10px', fontWeight: '400', fontSize: '16px' }}>
          { staticContent.unexpectedErrorBody ||
            'We are sorry, but something did not go as planned. Thank you for your patience as we resolve it.' }
        </Text>

        <Button
          style={{
            color: 'white',
            backgroundColor: 'black',
            marginTop: '10px'
          }}
          size='small'
          design='primary'
          onClick={ () => {
            trackC1(
              MetricsEvents.APPOINTMENTS_ZERO_STATE_ADD_RECOMMENDED_SERVICES_RELOAD_CTA_CLICK
            );
            onReload();
          } }
        >
          { staticContent.reload || 'Reload' }
        </Button>
      </Card>
    </>
  );
};

SuggestedServicesErrorScreen.propTypes = {
  staticContent: PropTypes.object.isRequired,
  onReload: PropTypes.func
};

export default SuggestedServicesErrorScreen;
